import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext(null);

const SUPPORTED = ["pt", "fr", "en"];

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        const saved = localStorage.getItem("tm-lang");
        return SUPPORTED.includes(saved) ? saved : "pt";
    });

    useEffect(() => {
        localStorage.setItem("tm-lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const setLanguage = (next) => {
        if (SUPPORTED.includes(next)) setLang(next);
    };

    return (
        <LanguageContext.Provider value={{ lang, setLanguage, SUPPORTED }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLanguage must be used within a LanguageProvider");
    return ctx;
}
